import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  ButtonGroup,
  Dropdown,
  MenuButton,
  Menu,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  FormControl,
  FormLabel,
  Stack,
  MenuItem,
  Select,
  Option,
  ModalOverflow,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle, StatusBadge } from "../../../components";
import { formatDate } from "../../../utils";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import {
  fetchAccountReset,
  fetchAccountRequest,
  viewAgentAccountRequest,
  viewAgentAccountReset,
  viewPartnerAccountRequest,
  viewPartnerAccountReset,
  createPartnerAccountRequest,
  createPartnerAccountReset,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  AddCardOutlined,
  CalendarMonthOutlined,
  FilterAltOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import { NAVIGATE_TO_ACCOUNTVIEWPAGE } from "../../../route/types";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography fontWeight={600} gutterBottom>
                  {listItem.account_code}
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Owner: </b> {listItem.owner}
                </Typography>

                <Dropdown>
                  <MenuButton variant="plain" size="sm">
                    More ...
                  </MenuButton>
                  <Menu placement="bottom-end" sx={{ p: 1 }}>
                    <Typography level="body-sm" gutterBottom>
                      <b>Created at: </b> {formatDate(listItem.created_at)}
                    </Typography>
                    {/* <Typography level="body-sm" gutterBottom><b>Approved at: </b>{formatDate(listItem.approved_at)}</Typography> */}
                    <Typography level="body-xs" gutterBottom>
                      <b>Created by: </b>
                      {`${listItem.created_by?.first_name || ""} ${listItem.created_by?.middle_name || ""} ${listItem.created_by?.last_name || ""}`}
                    </Typography>
                  </Menu>
                </Dropdown>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "neutral",
                    4: "danger",
                    5: "neutral",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "pending for approval",
                    4: "Rejected",
                    5: "Pending for additional",
                  }[listItem.status]
                }
              </StatusBadge>
              <ButtonGroup variant="soft" size="sm">
                <Button color="primary" onClick={() => props.view(listItem)}>
                  <RemoveRedEyeOutlined />
                </Button>
              </ButtonGroup>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          // width: '100%',
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
              bgcolor: "var(--TableCell-headBackground)",
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: 80, padding: "10px 5px" }}>Account Code</th>
              <th style={{ width: 80, padding: "10px 5px" }}>Owner</th>
              <th style={{ width: 80, padding: "10px 5px" }}>
                Bank Account Number
              </th>
              <th style={{ width: 50, padding: "10px 5px" }}>Status</th>
              <th aria-label="last" style={{ width: 30, padding: "10px 5px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm">{row.account_code}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.owner}</Typography>
                </td>
                <td>
                  <Typography
                    level="body-sm"
                    sx={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {row.ref_bank_number}
                  </Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "neutral",
                        4: "danger",
                        5: "neutral",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "pending for approval",
                        4: "Rejected",
                        5: "Pending for additional",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <ButtonGroup variant="soft" size="sm">
                    <Button
                      title="View"
                      color="primary"
                      onClick={() => props.view(row)}
                    >
                      <RemoveRedEyeOutlined />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const AccountPage = ({
  loginResult,

  accountListStatus,
  accountListResult,
  accountListErrorMessage,

  addAccountStatus,
  addAccountResult,
  addAccountErrorMessage,

  viewAccountStatus,
  viewAccountResult,
  viewAccountErrorMessage,

  viewPartnerAccountStatus,
  viewPartnerAccountResult,
  viewPartnerAccountErrorMessage,

  viewAgentAccountStatus,
  viewAgentAccountResult,
  viewAgentAccountErrorMessage,

  createPartnerAccountStatus,
  createPartnerAccountResult,
  createPartnerAccountErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { from, id, nm, accountsCount, partner_status } = state || {};
  const isDesktop = useMediaQuery("(min-width:600px)");

  const [accountData, setAccountData] = useState([]);

  const [name, setName] = useState("");
  const [accType, setAccType] = useState("");
  const [bankAcc, setBankAcc] = useState("");
  const [accForm, setAccForm] = useState(false);

  useEffect(() => {
    if (accountListStatus === STATUS.SUCCESS) {
      setAccountData(accountListResult);
      dispatch(fetchAccountReset());
    } else if (accountListStatus === STATUS.ERROR) {
      // setAccountData([]);
      toast.error(accountListErrorMessage);
      dispatch(fetchAccountReset());
    }

    if (viewPartnerAccountStatus === STATUS.SUCCESS) {
      setAccountData(viewPartnerAccountResult);
      dispatch(viewPartnerAccountReset());
    } else if (viewPartnerAccountStatus === STATUS.ERROR) {
      setAccountData([]);
      toast.error(viewPartnerAccountErrorMessage);
      dispatch(viewPartnerAccountReset());
    }

    if (viewAgentAccountStatus === STATUS.SUCCESS) {
      setAccountData(viewAgentAccountResult);
      dispatch(viewAgentAccountReset());
    } else if (viewPartnerAccountStatus === STATUS.ERROR) {
      setAccountData([]);
      toast.error(viewAgentAccountErrorMessage);
      dispatch(viewAgentAccountReset());
    }

    if (createPartnerAccountStatus === STATUS.SUCCESS) {
      toast.success("Account created successful");
      setAccForm(false);
      dispatch(createPartnerAccountReset());
      dispatch(viewPartnerAccountRequest(loginResult.token, { id: id }));
    } else if (createPartnerAccountStatus === STATUS.ERROR) {
      toast.error(createPartnerAccountErrorMessage);
      dispatch(createPartnerAccountReset());
    }
  });

  const handleAccontType = (event, newValue) => {
    setAccType(newValue);
  };

  const createAccount = (event) => {
    event.preventDefault();
    if (accType) {
      const datas = {
        partner_id: id,
        ref_bank_acc: bankAcc,
        ref_bank_id: id,
        account_type: accType,
      };
      // alert(JSON.stringify(datas))
      dispatch(createPartnerAccountRequest(loginResult.token, datas));
    } else {
      toast.error("Please fill all required information for account creation");
    }
  };

  useEffect(() => {
    if (from === "agent") {
      // alert("hello agent acc")
      dispatch(viewAgentAccountRequest(loginResult.token, { id: id }));
    } else if (from === "partner") {
      dispatch(viewPartnerAccountRequest(loginResult.token, { id: id }));
    } else if (from !== "partner" && from !== "agent") {
      dispatch(fetchAccountRequest(loginResult.token));
    }
  }, [from]);

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  // filtre by  name
  const filteredData = accountData.filter((item) => {
    if (filterBy === "name") {
      return item.account_name.toLowerCase().includes(search.toLowerCase());
    } else if (filterBy === "owner") {
      return item.owner.toLowerCase().includes(search.toLowerCase());
    } else if (filterBy === "date") {
      return item.created_at.includes(search);
    } else if (filterBy === "created_by") {
      return item.created_by;
    } else {
      return item.account_name.toLowerCase().includes(search.toLowerCase());
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  /* -------- actions ----------- */
  const goToViewPage = (details) => {
    navigate(NAVIGATE_TO_ACCOUNTVIEWPAGE, {
      state: {
        account_code: details.account_code,
        id: id,
        user_type: "partner",
      },
    });
  };

  const checkLoading = () => {
    if (
      accountListStatus === STATUS.LOADING ||
      addAccountStatus === STATUS.LOADING ||
      viewAgentAccountStatus === STATUS.LOADING ||
      createPartnerAccountStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={nm ? nm + " Accounts" : "Manage Accounts"} />

      <LoadingView loading={checkLoading()} />

      {partner_status === 1 && loginResult.role === 1 && accountsCount < 2 && (
        <Button
          color="neutral"
          startDecorator={<AddCardOutlined />}
          onClick={() => setAccForm(true)}
        >
          Create Account
        </Button>
      )}

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          // width: { xs: 'auto', md: '30%' },
          justifyContent: "space-between",
        }}
      >
        {accountData.length > 0 && (
          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type={{ date: "date", name: "text", owner: "text" }[filterBy]}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={
              filterBy === "date" ? <CalendarMonthOutlined /> : <SearchIcon />
            }
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  {/* <Typography level="body-sm">Filter</Typography> */}
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("owner")}
                    selected={filterBy == "owner"}
                  >
                    Owner
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("date")}
                    selected={filterBy == "date"}
                  >
                    Created at
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("created_by")}
                    selected={filterBy == "created_by"}
                  >
                    Created by
                  </MenuItem>
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        )}
      </Sheet>

      {accountData.length > 0 ? (
        <>
          {/* ------ render different view depend on plafform -------- */}
          <MobileViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />
          <DesktopViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />

          {/* Pagination */}
          {accountData.length > ITEMS_PER_PAGE && (
            <Box
              className="Pagination-laptopUp"
              sx={{
                pt: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                display: "flex",
              }}
            >
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                startDecorator={<KeyboardArrowLeftIcon />}
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
              >
                {isDesktop ? "Previous" : ""}
              </Button>

              <Box sx={{ flex: 1 }} />
              {/* for desktop to display page number */}
              {Array.from({ length: pageLength }).map((_, page) => (
                <IconButton
                  key={page}
                  size="sm"
                  variant={"outlined"}
                  color="neutral"
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {page + 1}
                </IconButton>
              ))}

              {/* for mobile to display page number */}
              <Typography
                level="body-sm"
                mx="auto"
                textAlign={"center"}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Page {currentPage + 1} of {pageLength}
              </Typography>
              <Box sx={{ flex: 1 }} />

              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                endDecorator={<KeyboardArrowRightIcon />}
                onClick={handleNextPage}
                disabled={currentPage === pageLength - 1}
              >
                {isDesktop ? "Next" : ""}
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: "20%",
          }}
        >
          <WarningRounded
            sx={{ fontSize: "50px", color: "background.appcolor" }}
          />
          <Typography level="title-md">Resource not Found</Typography>
          <Typography level="body-sm" textAlign={"center"}>
            This can be either no Account list available or network issue.
          </Typography>
          {/* <Button onClick={() => dispatch(fetchAccountRequest(loginResult.token))} startDecorator={<RefreshOutlined />} >REFRESH</Button> */}
        </Card>
      )}

      {/* ------ Modal form for create account ------ */}
      <Modal open={accForm}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            // aria-labelledby="modal-dialog-overflow"
            // layout="fullscreen"
            sx={(theme) => ({
              // pt: '600px',
              minWidth: { xs: "unset", md: "800px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                // borderRadius: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose variant="outlined" onClick={() => setAccForm(false)} />
            <DialogTitle>{`Edit ${name} Details`}</DialogTitle>
            <DialogContent>
              Please enter required details for account creation.
            </DialogContent>
            <Stack
              component="form"
              onSubmit={createAccount}
              gap={2}
              sx={{ mt: 2 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* account type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Account Type</FormLabel>
                  <Select
                    placeholder="Select account type"
                    value={accType}
                    onChange={handleAccontType}
                    required
                  >
                    <Option value="individual_account">Individual</Option>
                    <Option value="business_account">Business</Option>
                    <Option value="customer_suspense_account">
                      Customer Suspense
                    </Option>
                    <Option value="agent_suspense_account">
                      Agent Suspense
                    </Option>
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* bank ref account */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Bank Ref Account</FormLabel>
                  <Input
                    type="text"
                    value={bankAcc}
                    onChange={(e) => setBankAcc(e.target.value)}
                    placeholder="Enter bank ref account"
                  />
                </FormControl>
              </Stack>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Create Account
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ accounts, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    accountListResult,
    accountListStatus,
    accountListErrorMessage,

    addAccountStatus,
    addAccountResult,
    addAccountErrorMessage,

    viewAccountStatus,
    viewAccountResult,
    viewAccountErrorMessage,

    viewPartnerAccountStatus,
    viewPartnerAccountResult,
    viewPartnerAccountErrorMessage,

    viewAgentAccountStatus,
    viewAgentAccountResult,
    viewAgentAccountErrorMessage,

    createPartnerAccountStatus,
    createPartnerAccountResult,
    createPartnerAccountErrorMessage,
  } = accounts;

  return {
    loginResult,

    accountListStatus,
    accountListResult,
    accountListErrorMessage,

    addAccountStatus,
    addAccountResult,
    addAccountErrorMessage,

    viewAccountStatus,
    viewAccountResult,
    viewAccountErrorMessage,

    viewPartnerAccountStatus,
    viewPartnerAccountResult,
    viewPartnerAccountErrorMessage,

    viewAgentAccountStatus,
    viewAgentAccountResult,
    viewAgentAccountErrorMessage,

    createPartnerAccountStatus,
    createPartnerAccountResult,
    createPartnerAccountErrorMessage,
  };
};

export default connect(mapStateToProps, {})(AccountPage);
